import { render, staticRenderFns } from "./CandidatesSetZoomPresentie.vue?vue&type=template&id=a4d6c634&scoped=true&lang=pug&"
import script from "./CandidatesSetZoomPresentie.vue?vue&type=script&lang=js&"
export * from "./CandidatesSetZoomPresentie.vue?vue&type=script&lang=js&"
import style0 from "./CandidatesSetZoomPresentie.vue?vue&type=style&index=0&id=a4d6c634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d6c634",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
